import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import LoadingApiQuery from "../../../../../components/LoadingApiQuery";
import { TConfigComercial } from "../../../../../types/api/geral/configuracoes";
import { useCallback, useEffect, useMemo, useState } from "react";
import DisplayNotFoundInfo from "../../../../../components/DisplayNotFindInfo";
import { Button, Divider, Stack, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import DialogAddConfig from "./DialogAddConfig";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from "@mui/icons-material/Edit";

export default function DialogConfigPedidos() {

    const [openModal, setOpenModal] = useState<TOpenModalConfigPedidos>(null)
    const [possuiDados, setPossuiDados] = useState(false);

    //queries e mutations
    const { data, isLoading: isLoadingConfiguracoes, refetch } = useQuery({
        queryKey: ["configuracoes-conta-transitoria"],
        queryFn: () => axiosClient.get("/configuracoes", {
            params: {
                chave: 'comercial'
            }
        }),
        onSuccess(data) {
            const temChave = data.data?.hasOwnProperty("condicao_pagamento") || data.data?.hasOwnProperty("conta_transitoria");
            if (temChave) {
                setPossuiDados(true)
            }
        },
    });
    const dataConfigComercial: TConfigComercial | null = useMemo(() => {
        if (!data?.data) return null;
        return data.data;
    }, [data]);
    //

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TConfigComercial | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    useEffect(() => {
        refetch();
    }, [refetch]);

    if (isLoadingConfiguracoes || !dataConfigComercial)
        return <LoadingApiQuery extraParams={{ height: 150, alignItems: 'center' }} />

    return (
        <>

            <Stack direction={'row'} justifyContent="space-between" alignItems="flex-start" mb={3}>
                <Typography variant="h6">Pedido configurações</Typography>

                <Button variant="outlined" startIcon={possuiDados ? <EditIcon /> : <AddIcon />} onClick={() => {
                    possuiDados ? handleModalAction('open', true, dataConfigComercial) : handleModalAction('open', true, null)
                }}>
                    {possuiDados ? "Editar" : "Adicionar"}
                </Button>

            </Stack>

            <Grid container spacing={2}>

                {
                    !dataConfigComercial.conta_transitoria &&
                    <Grid size={{xs: 12}}>
                        <DisplayNotFoundInfo
                            label="Nenhuma conta transitória configurada"
                        />
                    </Grid>
                }
                {
                    dataConfigComercial.conta_transitoria &&
                    <Grid container size={{xs: 12}} spacing={2}>
                        <Grid size={{xs: 12}}>
                            <Typography><b>Conta transitória</b></Typography>
                        </Grid>
                        <Grid size={{xs: 12, md: 6}}>
                            <Stack direction="column" alignItems="flex-start" spacing={1}>
                                <Typography variant="subtitle2">Conta</Typography>
                                <Typography variant="body2" fontWeight={600}>
                                    {dataConfigComercial.conta_transitoria.codigo_contabil} - {dataConfigComercial.conta_transitoria.nome}
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid size={{xs: 12, md: 6}}>
                            <Stack direction="column" alignItems="flex-start" spacing={1}>
                                <Typography variant="subtitle2">Centro de custo</Typography>
                                <Typography variant="body2" fontWeight={600}>
                                    {dataConfigComercial.conta_transitoria.centro_custo ? `${dataConfigComercial.conta_transitoria.centro_custo.id} - ${dataConfigComercial.conta_transitoria.centro_custo.nome}` : '-'}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                }
                <Grid size={{xs: 12}}>
                    <Divider />
                </Grid>
                {
                    !dataConfigComercial.condicao_pagamento &&
                    <Grid size={{xs: 12}}>
                        <DisplayNotFoundInfo
                            label="Nenhuma condição de pagamento configurada"
                        />
                    </Grid>
                }
                {
                    dataConfigComercial.condicao_pagamento &&
                    <Grid container size={{xs: 12}} spacing={2}>
                        <Grid size={{xs: 12}}>
                            <Typography><b>Condição de pagamento</b></Typography>
                        </Grid>
                        <Grid size={{xs: 12, md: 6}}>
                            <Stack direction="column" alignItems="flex-start" spacing={1}>
                                <Typography variant="subtitle2">Código</Typography>
                                <Typography variant="body2" fontWeight={600}>
                                    {dataConfigComercial.condicao_pagamento}
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid size={{xs: 12}}>
                            <Divider />
                        </Grid>
                        <Grid container size={{xs: 12}} spacing={2}>
                            <Grid size={{xs: 12}}>
                                <Typography><b>Acréscimo</b></Typography>
                            </Grid>
                            <Grid size={{xs: 12}}>
                                <Typography variant="body2"> {dataConfigComercial.possui_acrescimo ? "Sim" : "Não"}
                                </Typography>
                            </Grid>
                            {
                                dataConfigComercial.possui_acrescimo && (
                                    <Grid size={{xs: 12}}>
                                        <Typography variant="body2" fontWeight={600}>
                                            {dataConfigComercial.percentual_acrescimo ? `${dataConfigComercial.percentual_acrescimo}%` : "Não definido"}
                                        </Typography>
                                    </Grid>
                                )
                            }
                        </Grid>
                    </Grid>
                }
            </Grid>

            {
                Boolean(openModal?.open) &&
                <DialogAddConfig
                    open={Boolean(openModal?.open)}
                    previousValue={openModal?.defaultValue ? openModal.defaultValue : null}
                    handleClose={() => handleModalAction('close')}
                    onSubmit={() => {
                        refetch()
                        handleModalAction('close')
                    }}
                />
            }
        </>
    )
}

export type TOpenModalConfigPedidos = {
    open: number | boolean | null;
    defaultValue: TConfigComercial | null;
} | null

